import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `${title}`;
    } else {
      document.title = `Mynexo | Social Gaming Entertainment`;
    }
  }, [title]);
};
